import { mergeDeepRight } from 'ramda';
import * as types from '../constants/ActionTypes';

/**
 * {
 *   [chatId]: {
 *     pdf: <react-pdf document>,
 *     isSending: true if there is an active request for that chat, false otherwise
 *   },
 * }
 */
const pdf = (state = {}, action) => {
  switch (action.type) {
    case types.PDF_BUILD_START:
    case types.PDF_BUILD_FINISH:
    case types.PDF_SEND_TO_INBOX_SUCCESS:
    case types.PDF_SEND_TO_INBOX_FAIL:
    case types.PDF_SEND_TO_INBOX_TIMEOUT:
    case types.PDF_SEND_TO_INBOX_CONFIRM:
    case types.PDF_CLEAR_STATUS:
      return mergeDeepRight(state, action.payload);
    case types.PDF_SEND_TO_INBOX :
      const chatId = action.payload;
      const chatState = {
        [chatId]: { ...state[chatId], isSending: true },
      };
      return mergeDeepRight(state, chatState);
    default:
      return state;
  }
};

export default pdf;
